<!--我的账户-->
<template>
  <el-tabs v-model="activeName" type="card" class="tabs-one" style="padding-top: 20px;">
    <el-tab-pane name="1" class="active">
      <span slot="label"><i class="el-icon"></i>申请管理</span>
      <applicationManagement></applicationManagement>
    </el-tab-pane>
    <el-tab-pane name="2">
      <span slot="label"><i class="el-icon"></i>合作中的理财顾问</span>
      <inCooperation></inCooperation>
    </el-tab-pane>
    <el-tab-pane name="3">
      <span slot="label"><i class="el-icon"></i>终止合作的理财顾问</span>
      <endTheCooperation v-if="activeName == '3'"></endTheCooperation>
    </el-tab-pane>
    <el-tab-pane name="4">
      <span slot="label"><i class="el-icon"></i>客户关系管理</span>
      <crm v-if="activeName == '4'"></crm>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import applicationManagement from "./applicationManagement";
import inCooperation from "./inCooperation";
import endTheCooperation from "./endTheCooperation";
import crm from "./CRM"
export default {
  components: {
    applicationManagement,
    inCooperation,
    endTheCooperation,
    crm
  },
  data () {
    return {
      activeName: '1',
    }
  },
  created () {
    this.activeName = this.$route.params.active ? this.$route.params.active : '1'
  },
  methods: {

  }

}
</script>

<style lang="less" scoped>
</style>
